module.exports = __webpack_public_path__ + "assets/img/travel-day27.8844cf80.png";